import React from "react";

import "./SnackBar.scss";

interface Props {
    content: string | React.ReactNode | undefined;
    active: boolean;
}

const SnackBar = ({ content, active}: Props) => {

    return (
        <div data-component-name="SnackBar" className={active ? "snackbar show" : "snackbar hide"}>
            {content}
        </div>
    );
};

export { SnackBar };
